export const ARNM_REPAIRS_FIELDS_TO_SEARCH = [
  { label: 'id', value: 'id' },
  { label: 'vehiclePlate', value: 'customFields.vehiclePlate' },
  { label: 'carId', value: 'customFields.carId' },
];
